<div class="col full-height layout-column">


  <cdk-virtual-scroll-viewport *ngIf="!!routes && !!routes?.length"
                               #viewport
                               class="flex"
                               cdkDropList
                               [cdkDropListData]="routes"
                               [id]="panel.id + '_routes'"
                               [cdkDropListConnectedTo]="connectedPanelIds"
                               [cdkDropListSortingDisabled]="true"
                               [cdkDropListAutoScrollDisabled]="true"
                               [itemSize]="itemSize"
                               [minBufferPx]="600"
                               [maxBufferPx]="1200">
    <app-planning-draft-routes-panel-list-item *cdkVirtualFor="let route of routes; trackBy: trackByRouteId; templateCacheSize: 40"
                                               cdkDrag
                                               [cdkDragData]="route"
                                               cdkDropList
                                               [cdkDropListData]="route.activities"
                                               [id]="route.id"
                                               [cdkDropListSortingDisabled]="true"
                                               [cdkDropListConnectedTo]="connectedPanelIds"
                                               (cdkDropListDropped)="onDrop(route, $event)"
                                               [route]="route"
                                               [logisticsVehicleName]="logisticsVehicleNameByResourceId[route.resourceId]"
                                               [draft]="draft"
                                               [jobs]="jobs"
                                               [settings]="settings"
                                               [isSelected]="selectedKeys[route.id]"
                                               [isVisible]="visibleKeys[route.id]"
                                               [canSelect]="true"
                                               [canDrilldown]="true"
                                               [itemElementSize]="itemElementSize"
                                               [isShowActionMenu]="true"
                                               (onToggle)="onToggleSelectedRoute(route.id, $event)"
                                               (onToggleVisible)="onToggleVisibleRoute(route.id, $event)"
                                               (onSelect)="onSelect.emit({ route: route, scrollOffset: viewport.measureScrollOffset() })"
                                               (onLockRouteChange)="onLockRouteChange.emit($event)"
                                               (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                               (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                               (onDrillDown)="onDrillDown.emit($event)"
                                               (onDispatch)="onDispatch.emit($event)"
                                               (onReoptimize)="onReoptimize.emit($event)"
                                               (onPreAssignAgent)="onPreAssignAgent.emit($event)"
                                               (onPrint)="onPrint.emit($event)"
                                               (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                               (onDelete)="onDelete.emit($event)"
                                               (onFeedback)="onFeedback.emit($event)">

      <div cdkDragHandle appBringozIdGenerator="drag-route-route-routes-panel">
        <bringoz-icon iconName="drag" class="secondary-100"></bringoz-icon>
      </div>

    </app-planning-draft-routes-panel-list-item>

  </cdk-virtual-scroll-viewport>


  <div *ngIf="!routes?.length"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                     text="No Routes Found">

    </app-empty-state>
  </div>

  <!-- Custom drop animations -->
  <div *ngFor="let anim of dropAnimations"
       class="custom-drop-animation"
       [ngClass]="{'multiple-items': anim.isMultiple}"
       [style.left.px]="anim.x"
       [style.top.px]="anim.y">

    <!-- Single item animation - looks like activity item -->
    <div *ngIf="!anim.isMultiple" class="activity-item-preview">
      <div class="activity-icon">
      </div>
      <div class="activity-content">
        <div class="activity-title">{{ anim.text }}</div>
        <div class="activity-subtitle">Drop complete</div>
      </div>
    </div>

    <!-- Multiple items animation - looks like the blue drag preview -->
    <div *ngIf="anim.isMultiple" class="multiple-items-preview">
      <span>{{ anim.count }} Jobs Added</span>
    </div>
  </div>

</div>


<!--<div class="col full-height layout-column">-->

<!--  <div class="flex layout-column dndList overflow-auto">-->

<!--    <app-planning-draft-routes-panel-list-item *ngFor="let route of routes"-->
<!--                                               [route]="route"-->
<!--                                               [settings]="settings"-->
<!--                                               [isSelected]="selectedKeys[route.id]"-->
<!--                                               [canSelect]="true"-->
<!--                                               (onToggle)="onToggleSelectedRoute(route.id, $event)"-->
<!--                                               (onSelect)="onSelect.emit(route)">-->

<!--    </app-planning-draft-routes-panel-list-item>-->

<!--  </div>-->
<!--</div>-->
